<template>
  <div class="main">
    <report-top>
      <ly-search
        slot="search"
        v-model="searchItem.keyword"
        @search="search"
      ></ly-search
    ></report-top>
    <div id="formTable">
      <div class="formTableItem">
        <p class="label">时间范围</p>
        <start-end ref="startEnd" timeModel="2,3,0"></start-end>
      </div>
      <div class="formTableItem">
        <Button @click="chaxun" size='small' type="primary" class="chaxun">查询列表</Button
        ><Button @click="dayin" size='small' type="error" class="chaxun">打印工单</Button>
      </div>
    </div>

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)"
      @on-selection-change="selectTableData = $event"
    >
      <viewer slot-scope="{ row, index }" :slot="'action'">
        <img
          v-for="(y, index1) in row.fileList"
          :key="index1"
          :src="axios.platConfig.fileUri + y"
          width="24"
          height="24"
          style="margin-right: 4px; cursor: pointer"
        />
      </viewer>
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="searchItem.pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
    <docDetail v-if="false" ref="docDetail"></docDetail>
    <dayin ref="dayin"></dayin>
  </div>
</template>
<script>
import fields from "../yhgl/forms/fields";
import docDetail from "../yhgl/docDetail.vue";
import dayin from "./dayin.vue";
export default {
  components: { docDetail, dayin },
  data() {
    return {
      isAdd: false,
      columns: [
        {
          type: "selection",
          width: 70,
          align: "center",
          tooltip: true,
        },
        { title: "工单号", key: "workNo", maxWidth: 300, minWidth: 100 },
        { title: "开始作业", key: "startTime2", maxWidth: 300, minWidth: 100 },
        { title: "结束作业", key: "endTime2", maxWidth: 300, minWidth: 100 },
        { title: "作业时长/分", key: "duration", maxWidth: 300, minWidth: 100 },

        {
          title: "监管单位",
          key: "dept",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "养护单位",
          key: "groupName",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "养护项目",
          key: "itemList",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "作业地点",
          key: "address",
          required: true,
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "要求作业日期",
          key: "mustDate2",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "实际作业日期",
          key: "realDate2",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "起止桩号",
          key: "pileNoList",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "班组长",
          key: "workLeader",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "派工人员",
          key: "dispatcher",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "是否办结",
          key: "isFinish2",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "流程图片",
          slot: "action",
          key: "fileList",
          show: "photo",
          span: 24,
          maxWidth: 300,
          minWidth: 100,
        },
      ],
      tableData: [],
      selectTableData:[],
      searchItem: {
        keyword: "",
        pageNumber: 1,
        pageSize: 50,
      },
      total: 0,
      selectTableData:[]
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-rmm-server-rpt/care/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        console.log(data);
        for (let i = 0; i < data.length; i++) {
          //data[i].time2 = this.utils.time(data[i].time, "yymmdd");
          data[i].startTime2 = this.utils.time(data[i].startTime, "yymmddhhmm");
          data[i].endTime2 = this.utils.time(data[i].endTime, "yymmddhhmm");
          data[i].realDate2 = this.utils.time(data[i].realDate, "yymmdd");
          data[i].mustDate2 = this.utils.time(data[i].mustDate, "yymmdd");
          data[i].isFinish2 = this.$t("bool." + data[i].isFinish);
          data[i].itemList = data[i].itemList.join(" / ");
          data[i].pileNoList = data[i].pileNoList.join(" / ");
          data[i].qianzi = [];
        }
        this.tableData = data;
      });
    },
    detail(row) {
      var a = this.selectTableData;
      for (let i = 0; i < a.length; i++) {
        this.utils.loading(this, "加载中");
        this.axios({
          method: "post",
          url: this.axios.ipPort + "/cloud-rmm-server-dpm/care/item",
          data: { no: a[i].workNo },
        }).then((res) => {
          this.$Spin.hide(); //关闭加载
          a[i].qianzi = res.data.data.signList;
          if (i == this.selectTableData.length-1) {
            this.$refs.dayin.reach(this.selectTableData, this.columns);
          }
        });
      }
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    chaxun() {
      this.searchItem.startTime = this.$refs.startEnd.getTimeObj().start;
      this.searchItem.endTime = this.$refs.startEnd.getTimeObj().end;
      this.getList();
    },
    dayin() {
      if (this.selectTableData.length==0) {
        this.$Message.error("请选择条目");
        return
      }
      this.detail();
    },
    search() {
      this.getList();
    },
  },
  mounted() {
    this.chaxun();
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/yanghuzuoyechaxun/yanghupaigong.vue